import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { Button, Dropdown, Form, Grid, Input, Select } from 'semantic-ui-react';
import CustomerMasterForm from '../../../CustomerMaster/CustomerMasterForm';
import { useStore } from './../../../../app/stores/store';
import DepartmentMasterForm from '../../../DepartmentMaster/DepartmentMasterForm';
import { userLanguage } from '../../../../app/common/userLanguageSchema/userLanguage';

interface Props {
  handleSelect: any;
  customerSelected: string;
  departmentSelected: string;
  departmentClear: string;
  name?: string;
}

function CreateOrderForm({
  handleSelect,
  customerSelected,
  departmentSelected,
  departmentClear,
  name,
}: Props) {
  const {
    dashboardStore,
    customerStore,
    departmentStore,
    modalStore,
    userStore,
    commonStore,
  } = useStore();
  const { loadCustomers, customerRegistery, customeritemsByDate } =
    customerStore;
  const { loadDepartments, departmentRegistry, departmentitemsByDate } =
    departmentStore;

  const { user } = userStore;
  // to load all existing departments
  useEffect(() => {
    if (departmentRegistry.size <= 1) loadDepartments();
  }, [departmentRegistry.size, loadDepartments]);

  useEffect(() => {
    if (customerRegistery.size <= 1) loadCustomers();
  }, [customerRegistery.size, loadCustomers]);

  const filteredCustomers = customeritemsByDate.filter((x) =>
    dashboardStore.dashboard.selectedUserRoleId.includes(x.id),
  );
  const customeroptions = filteredCustomers.map((x) => ({
    key: x.customer_Name,
    text: x.customer_Name,
    value: x.id,
  }));

  const filteredDepartment = departmentitemsByDate.filter((x) =>
    dashboardStore.dashboard.selectedUserRoleId.includes(x.id),
  );
  const departmentoptions = filteredDepartment.map((x) => ({
    key: x.id,
    text: x.department_Name,
    value: x.id,
  }));

  return (
    <div>
      <Form>
        {name !== 'ViewpageOrder' ? (
          <Grid>
            <Grid.Row columns={2}>
              <Grid.Column width={15} style={{ marginRight: 'auto' }}>
                <p
                  style={{
                    marginLeft: '0px',
                    marginBottom: '2px',
                  }}
                >
                  <b //Client
                  >
                    {
                      (
                        userLanguage[0].Level3InventoryRecievingCreateOrder
                          ?.IRCOL02 as any
                      )?.[`${commonStore.language.key}`]
                    }
                  </b>
                </p>
                {user?.isAdmin ? (
                  <Form.Field
                    style={{ marginBottom: '3px' }}
                    clearable
                    fluid
                    search
                    selection
                    searchQuery={customerSelected}
                    control={Select}
                    options={customeroptions}
                    required
                    name="customerId"
                    // value={customerSelected}
                    placeholder="Select Client"
                    onChange={handleSelect}
                  />
                ) : (
                  <Input
                    style={{ marginBottom: '3px' }}
                    disabled
                    name="customerId"
                    searchQuery={customerSelected}
                    placeholder="Select Client"
                    defaultValue={user?.customerName}
                  />
                )}
              </Grid.Column>
              {user?.isAdmin && (
                <Grid.Column
                  width={1}
                  style={{
                    height: '34px',
                    alignSelf: 'flex-end',
                  }}
                >
                  <Button
                    className="add-department"
                    disabled={
                      dashboardStore.dashboard.selectedUserRoleId.includes(
                        'IRCOB01',
                      )
                        ? false
                        : true
                    }
                    onClick={() => modalStore.openModal(<CustomerMasterForm />)}
                    icon="plus"
                    positive
                    size="mini"
                  />
                </Grid.Column>
              )}
            </Grid.Row>
          </Grid>
        ) : null}

        <Grid.Column style={{ fontWeight: '550' }}>
          <Grid>
            <Grid.Row columns={2}>
              <Grid.Column width={15}>
                <p
                  className={
                    name !== 'ViewpageOrder'
                      ? 'COF-Department'
                      : 'COF-orderDepartment'
                  }
                  style={{
                    marginBottom: '2px',
                    marginTop: name !== 'ViewpageOrder' ? '12px' : '0',
                  }}
                >
                  <b
                  //Department
                  >
                    {
                      (
                        userLanguage[0].Level3InventoryRecievingCreateOrder
                          ?.IRCOL03 as any
                      )?.[`${commonStore.language.key}`]
                    }
                  </b>
                </p>
                <Dropdown
                  clearable
                  fluid
                  search
                  required
                  selection
                  searchQuery={departmentSelected}
                  options={departmentoptions}
                  name="departmentId"
                  value={departmentClear}
                  placeholder={
                    (
                      userLanguage[0].Level3InventoryRecievingCreateOrder
                        ?.IRCODD01 as any
                    )?.[`${commonStore.language.key}`]
                  } //"Select Department"
                  onChange={handleSelect}
                />
              </Grid.Column>
              <Grid.Column
                width={1}
                style={{
                  height: '34px',
                  alignSelf: 'flex-end',
                }}
              >
                <Button
                  className="add-department"
                  disabled={
                    dashboardStore.dashboard.selectedUserRoleId.includes(
                      'IRCOB10',
                    )
                      ? false
                      : true
                  }
                  onClick={() =>
                    modalStore.openModal(<DepartmentMasterForm isEdit />)
                  }
                  icon="plus"
                  positive
                  size="mini"
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Grid.Column>
      </Form>
    </div>
  );
}

export default observer(CreateOrderForm);
